"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asEditableCarousel = exports.BCarouselClean = exports.BAutoCarousel = exports.BCarousel = void 0;

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var core_1 = require("@bodiless/core");

var nuka_carousel_1 = __importDefault(require("nuka-carousel"));

var components_1 = require("@bodiless/components");

var components_ui_1 = require("@bodiless/components-ui");

var carouselStart = {
  Wrapper: fclasses_1.Div,
  Slider: components_1.List
};

var CarouselBase = function CarouselBase(_a) {
  var components = _a.components;
  var Wrapper = components.Wrapper,
      Slider = components.Slider;
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement(Slider, null));
}; // Define the slides <Carousel><div><img/></div></Carousel>
// HOC to apply to a List to make it a list of slides.


var asSlidesList = lodash_1.flow(fclasses_1.withDesign({
  Wrapper: fclasses_1.replaceWith(nuka_carousel_1.default),
  Item: fclasses_1.replaceWith(fclasses_1.Div),
  Title: fclasses_1.replaceWith(fclasses_1.Img)
}));
var BCarouselClean = lodash_1.flow(fclasses_1.designable(carouselStart, 'Carousel'), fclasses_1.withDesign({
  Slider: asSlidesList
}))(CarouselBase);
exports.BCarouselClean = BCarouselClean; // Allows the Image Editor form to work and not slide with the image.

var asNoDraggingSlider = core_1.ifEditable(fclasses_1.addProps({
  dragging: false
}));
/**
 * Adds data- identifiers to help select carousel elements in automated tests.
 *
 * @param id The id attribute to apply to the outer wrapper.
 */

var asTestableCarousel = fclasses_1.withDesign({
  Wrapper: fclasses_1.addProps({
    'data-carousel-element': 'wrapper'
  }),
  Slider: fclasses_1.withDesign({
    Item: fclasses_1.addProps({
      'data-carousel-element': 'slide'
    }),
    Title: fclasses_1.addProps({
      'data-carousel-element': 'slide-image'
    })
  })
}); // Replace my Slider div with Slides List.
// TO DO: This should move to Site Level because,
//        its currently the composition of combining Slide List + Carousel.

var asEditableCarousel = lodash_1.flow(core_1.withNode, fclasses_1.withDesign({
  Slider: lodash_1.flow(components_1.asEditableList, asNoDraggingSlider, core_1.withNodeKey('slides'), fclasses_1.withDesign({
    Title: components_ui_1.asBodilessImage('image')
  }))
}), asTestableCarousel);
exports.asEditableCarousel = asEditableCarousel;
var BCarousel = asEditableCarousel(BCarouselClean);
exports.BCarousel = BCarousel; // Auto rotating is only on in preview/static other you can edit an image.

var asAutoSlider = core_1.ifReadOnly(fclasses_1.addProps({
  autoplay: true,
  autoplayInterval: '3000',
  wrapAround: true
}));
var BAutoCarousel = fclasses_1.withDesign({
  Slider: asAutoSlider
})(BCarousel);
exports.BAutoCarousel = BAutoCarousel;
exports.default = BCarousel;